import { apiClient } from "../config";

async function forgotPassword(
  phoneOrEmail: any,
  password?: string,
  revokeAllSessions?: boolean
) {
  const requestData: { [key: string]: any } = {
    phone_or_email: phoneOrEmail,
    revokeAllSessions,
  };

  if (password && password.trim() !== "") {
    requestData.password = password;
  }

  const res = await apiClient.post(`/admin/forgot-password`, requestData);
  return res.data;
}

export default forgotPassword;
